import { useState } from 'react';
import { Modal, plural } from './ui.jsx';
import { getState, today } from '../data/store.js';
import { buildExport } from '../data/export.js';

/**
 * Free, self-service export of everything the gym owns.
 *
 * Deliberately not a support ticket, not a paid add-on, and not a summary.
 * Seven of the eighteen platforms in the teardown either charge for this or
 * make you ask; being the one that does not is the reason to switch, so it
 * lives two clicks from anywhere and states plainly what it contains.
 *
 * One file per download rather than a zip: adding an archive library to ship a
 * handful of CSVs is a poor trade, and a browser will not reliably fire six
 * downloads from one gesture. Each row is its own deliberate act, and every
 * file says how many records it holds so a short one is obvious before it is
 * opened somewhere else.
 */
function download(file) {
  const blob = new Blob([file.content], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = file.filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoking immediately can race the download in some browsers.
  setTimeout(() => URL.revokeObjectURL(url), 4000);
}

export default function ExportData({ onClose }) {
  const files = buildExport(getState(), { todayKey: today() });
  const [taken, setTaken] = useState(() => new Set());

  const take = (file) => {
    download(file);
    setTaken((prev) => new Set(prev).add(file.filename));
  };

  return (
    <Modal title="Export your data" onClose={onClose}>
      <p style={{ marginTop: 0, color: 'var(--ink-2)' }}>
        Everything here is yours, in plain CSV that opens in any spreadsheet.
        No fee, no ticket, no waiting.
      </p>

      <table className="data">
        <thead>
          <tr><th>File</th><th>Records</th><th className="right">Download</th></tr>
        </thead>
        <tbody>
          {files.map((f) => (
            <tr key={f.filename}>
              <td>
                <b>{f.label}</b>
                <div className="mono" style={{ fontSize: 11.5, color: 'var(--ink-3)' }}>
                  {f.filename}
                </div>
              </td>
              <td className="num">{plural(f.count, 'row', 'rows')}</td>
              <td className="right">
                <button
                  className={taken.has(f.filename) ? 'small' : 'small primary'}
                  onClick={() => take(f)}
                >
                  {taken.has(f.filename) ? 'Download again' : 'Download'}
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Modal>
  );
}
